import React, { Suspense } from 'react';

import Loading from './Loading';

const Loadable = (Component) => {
  return (props) => (
    <Suspense fallback={<Loading />}>
      <Component {...props} />
    </Suspense>
  );
};

export default Loadable;
